import React from 'react'
import { useLocation } from 'react-router'

import reduceChildRoutes from './reduceChildRoutes'
import { SidebarNavProps } from './SidebarNav'

const SidebarNavList = (props: { pages: SidebarNavProps['items'][number]['pages']; depth: number }) => {
    const { pages, depth } = props
    const router = useLocation()
    const currentRoute = router.pathname

    const childRoutes = pages.reduce((items, page) => reduceChildRoutes({ items, page, currentRoute, depth }), [])

    return <React.Fragment>{childRoutes}</React.Fragment>
}

export default SidebarNavList
